import config from 'baseConfig/pg/orders';

import {
  CHECKBOX,
  ORDER_TYPE_ITEMS,
  ORDER_SOURCE_ITEMS,
} from 'baseConfig/pg/constants';

export default {
  DEFAULT: {
    TABLE_COLUMNS: [
      {
        key: 'addedOnTime',
        displayName: 'Date & Time',
        width: 0.12,
        tooltip: {
          message: 'Order Created On',
        },
      },
      ...config.DEFAULT.TABLE_COLUMNS,
    ],
    FILTER_ITEMS: {
      ...config.DEFAULT.FILTER_ITEMS,
      orderType: {
        displayText: 'Order Type',
        type: CHECKBOX,
        items: ORDER_TYPE_ITEMS,
      },
      // orderSource: {
      //   displayText: 'Integration Type',
      //   type: CHECKBOX,
      //   items: ORDER_SOURCE_ITEMS,
      // },
    },
    SEARCH_ITEMS: [...config.DEFAULT.SEARCH_ITEMS],
  },
};
